import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';
import { environment } from '../../../../../../../environments/environment';
import { AuthService } from '../../../../../../@core/auth/auth.service';
import { ErrorService } from '../../../../../../@core/utils/error.service';
import { AvailableLot } from '../models/available-lot';
import { Order } from '../models/order';
import { PickList } from '../models/pick-list';
import { PromotionDTO } from '../models/promotion';


@Injectable({
  providedIn: 'root'
})
export class OrdersService {

  protected basePath = '/';

  protected hubPath = '/';
  public allOrders: Order[] = [];
  public selectedPickDate: Date;
  private destroyRef = inject(DestroyRef);
  constructor(
    protected httpClient: HttpClient,
    private authService: AuthService,
    private errorService: ErrorService,
  ) {
    this.basePath = environment.HOLLINGBERY_API_URL;
    this.hubPath = environment.PLATFORM_API_URL;
  }

  public getOrderStatuses(): string[] {
    return [
      'Pending',
      'Pre-pay',
      'Staged',
      'Preparing for Shipment',
      'Ready to Ship',
      'Verified for Shipment',
      'Shipped',
      'Final Review',
      'Completed'
    ]
  }

  public getAvailableLots(variety: string, cropYear: number, breweryId?: number): Observable<AvailableLot[]> {

    let queryParameters = new HttpParams();

    queryParameters = queryParameters.set('cropYear', (cropYear || '').toString());
    queryParameters = queryParameters.set('variety', (variety || '').toString());

    if (breweryId) {
      queryParameters = queryParameters.set('breweryId', breweryId.toString());
    }

    return this.httpClient.get<AvailableLot[]>(`${this.basePath}/api/orders/availableLot`,
      // return this.httpClient.get<AvailableLot[]>(`${this.hubPath}/api/inventory/lots/available`,
      {
        params: queryParameters
      }
    );
  }

  public getOrders(startDate?: Date, endDate?: Date, breweryId?: number): Observable<Order[]> {

    let queryParameters = new HttpParams();

    if (startDate && endDate) {
      queryParameters = queryParameters.set('startDate', startDate.toISOString());
      queryParameters = queryParameters.set('endDate', endDate.toISOString());
    }

    if (breweryId) {
      queryParameters = queryParameters.set('breweryId', breweryId.toString());
    }

    return this.httpClient.get<Order[]>(`${this.basePath}/api/orders`,
      {
        params: queryParameters
      }
    );
  }

  public putOrder(order: Order): Observable<Order[]> {
    return this.httpClient.put<Order[]>(`${this.basePath}/api/orders/${order.recordId}`, order);
  }


  public deleteOrderHub(orderNumber: string): Observable<Order> {
    return this.httpClient.delete<Order>(`${this.hubPath}/api/WebStore/Orders/byOrderNumber/${orderNumber}`);
  }

  public getOrder(orderId: number): Observable<Order> {
    return this.httpClient.get<Order>(`${this.basePath}/api/orders/${orderId}`);
  }

  public getPickList(pickDate: Date = null): Observable<PickList[]> {

    let queryParameters = new HttpParams();

    if (pickDate) {
      queryParameters = queryParameters.set('pickDate', (pickDate.toISOString() || new Date().toISOString()).toString());
    }


    return this.httpClient.get<PickList[]>(`${this.basePath}/api/orders/picklist`,
      {
        params: queryParameters
      }
    );
  }

  public updateAllOrders() {
    this.getOrders().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:x => {
      this.allOrders = x;
    }, error:err => {
      this.errorService.handleError(err);
    }});
  }

  public getPromotions(): Observable<PromotionDTO[]> {
    return this.httpClient.get<PromotionDTO[]>(`${this.hubPath}/api/Promotion/Promotions`,);
  }

  //Create Sales Invoice in erp based on flag saveERPFlag
  public createERPSalesInvoice(order: Order, saveERPFlag?: boolean): Observable<any> {

    let queryParameters = new HttpParams();
    if (saveERPFlag) {
      queryParameters = queryParameters.set(
        "saveERPFlag",
        saveERPFlag.toString()
      );
    }

    return this.httpClient.post<any>(`${this.hubPath}/api/webstore/paymentprocessing/createerpsalesinvoice`, order, {
      params: queryParameters,
    });
  }

  public putOrderHub(orderNumber: string, order: Order): Observable<Order> {

    return this.httpClient.put<Order>(`${this.hubPath}/api/WebStore/orders/byOrderNumber/${orderNumber}`, order);
  }
}
